import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  title: {
    text: 'Prepaid'
  },
  description: {
    multiText: [{
      text: '1.3 GB ',
      type: 'body-single-line-md-bold'
    }, {
      text: 'daily data left unlimited calls'
    }]
  },
  cta: {
    title: 'view detail'
  }
}, getTestId('ServiceCardWidgetContainer'));